<template>
  <v-dialog
    scrollable
    max-width="450"
    v-model="show"
    @click:outside="$emit('cancel')"
    @keydown.esc="$emit('cancel')"
  >
    <v-card>
      <v-card-title>
        {{ $t('people.people_list_export') }}
      </v-card-title>

      <v-card-text>
        <div class="text-left">
          <p>{{ $t('people.export_permission_error') }}</p>
        </div>
      </v-card-text>

      <v-card-actions class="justify-end mb-2">
        <Button
          plain
          class="me-2"
          color="gray"
          :text="$t('common.button.cancel')"
          @click="$emit('cancel')"
        />
        <Button
          class="me-2"
          color="primary"
          :text="$t('people.export')"
          @click="$emit('export')"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Button from '@/components/UI/Button'

export default {
  name: 'PeopleExportableDialog',
  props: ['show'],
  components: { Button },
}
</script>
